export const colorscales = {
    12: {
        levels: [
            '#2d764f',
            '#3e9743',
            '#64c228',
            '#b1d648',
            '#d8e76a',
            '#fffd5b',
            '#ffeb00',
            '#ffc700',
            '#fda310',
            '#ff6f0e',
            '#ed3006',
            '#9a0101',
        ],
        opacity: 0.8,
    },
    11: {
        levels: [
            '#2d764f',
            '#3e9743',
            '#64c228',
            '#b1d648',
            '#d8e76a',
            '#fffd5b',
            '#ffc700',
            '#fda310',
            '#ff6f0e',
            '#ed3006',
            '#9a0101',
        ],
        opacity: 0.8,
    },
    10: {
        levels: [
            '#2d764f',
            '#3e9743',
            '#64c228',
            '#b1d648',
            '#d8e76a',
            '#fffd5b',
            '#fda310',
            '#ff6f0e',
            '#ed3006',
            '#9a0101',
        ],
        opacity: 0.8,
    },
    9: {
        levels: [
            '#2d764f',
            '#3e9743',
            '#64c228',
            '#b1d648',
            '#fffd5b',
            '#fda310',
            '#ff6f0e',
            '#ed3006',
            '#9a0101',
        ],
        opacity: 0.8,
    },
    8: {
        levels: [
            '#2d764f',
            '#3e9743',
            '#64c228',
            '#fffd5b',
            '#fda310',
            '#ff6f0e',
            '#ed3006',
            '#9a0101',
        ],
        opacity: 0.8,
    },
    7: {
        levels: ['#3e9743', '#64c228', '#b1d648', '#fffd5b', '#fda310', '#ff6f0e', '#ed3006'],
        opacity: 0.8,
    },
    6: {
        levels: ['#3e9743', '#64c228', '#b1d648', '#fffd5b', '#ff6f0e', '#ed3006'],
        opacity: 0.8,
    },
    5: {
        levels: ['#3e9743', '#b1d648', '#fffd5b', '#fda310', '#ed3006'],
        opacity: 0.8,
    },
    4: {
        levels: ['#3e9743', '#fffd5b', '#fda310', '#ed3006'],
        opacity: 0.8,
    },
    3: {
        levels: ['#b1d648', '#fffd5b', '#fda310'],
        opacity: 0.8,
    },
    2: {
        levels: ['#2d764f', '#9a0101'],
        opacity: 0.8,
    },
};
